import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-right flex flex-col" }
const _hoisted_4 = { class: "text-xs" }
const _hoisted_5 = { class: "px-6 py-4" }
const _hoisted_6 = { class: "px-6 py-4 items-center" }
const _hoisted_7 = {
  key: 0,
  class: "px-6 py-4 text-right flex flex-col"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_10 = { class: "font-numeric" }
const _hoisted_11 = {
  key: 1,
  class: "px-6 py-4 text-right flex flex-col"
}
const _hoisted_12 = { class: "text-right flex flex-col" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_15 = { class: "font-numeric" }
const _hoisted_16 = { class: "mt-2 text-gray-500 font-numeric" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_TokenPills = _resolveComponent("TokenPills")!
  const _component_BalChip = _resolveComponent("BalChip")!
  const _component_BalTable = _resolveComponent("BalTable")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, {
    shadow: "lg",
    class: "mt-4",
    noPad: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BalTable, {
        sticky: "both",
        columns: _ctx.columns,
        data: _ctx.data,
        "is-loading": _ctx.isLoading,
        "skeleton-class": "h-64",
        link: {
        to: 'pool',
        getParams: pool => ({ id: pool.id })
      },
        "initial-state": { sortDirection: 'desc', sortColumn: _ctx.latestWeek }
      }, _createSlots({
        iconColumnHeader: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              src: require('@/assets/images/icons/tokens_black.svg')
            }, null, 8, _hoisted_2)
          ])
        ]),
        iconColumnCell: _withCtx((pool) => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_BalAssetSet, {
              addresses: _ctx.orderedTokenAddressesFor(pool),
              width: 100
            }, null, 8, ["addresses"])
          ])
        ]),
        poolNameCell: _withCtx((pool) => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_TokenPills, {
              tokens: _ctx.orderedPoolTokens(pool),
              isStablePool: _ctx.isStableLike(pool.poolType)
            }, null, 8, ["tokens", "isStablePool"]),
            (pool.dynamic?.isNewPool)
              ? (_openBlock(), _createBlock(_component_BalChip, {
                  key: 0,
                  color: "red",
                  size: "sm",
                  class: "ml-2 uppercase",
                  outline: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('new')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, [
        _renderList(_ctx.weeks, (week, i) => {
          return {
            name: `header-${week.week}`,
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getWeekName(week.week)), 1),
                _createElementVNode("span", _hoisted_4, "Starts " + _toDisplayString(_ctx.getWeekStart(_ctx.weeks.length - i - 1)), 1)
              ])
            ])
          }
        }),
        _renderList(_ctx.weeks, (week, i) => {
          return {
            name: week.week,
            fn: _withCtx((pool) => [
              (pool.distributions[i].distribution)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pool.distributions[i]
              .distribution, (tokenDist, tokenIndex) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: tokenDist.tokenAddress
                      }, [
                        (tokenIndex !== 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "+"))
                          : _createCommentVNode("", true),
                        _hoisted_9,
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.fNum2(tokenDist.amount, {
                style: 'decimal',
                maximumFractionDigits: 0
              })), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.tokens[_ctx.getAddress(tokenDist.tokenAddress)]?.symbol || 'N/A'), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, " - "))
            ])
          }
        }),
        _renderList(_ctx.weeks, (week) => {
          return {
            name: `totals-${week.week}`,
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totals[week.week], ({ token, total }, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: `totals-${token}`,
                    class: "font-semibold text-right"
                  }, [
                    (i !== 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "+"))
                      : _createCommentVNode("", true),
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.fNum2(total, { style: 'decimal', maximumFractionDigits: 0 })), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.tokens[_ctx.getAddress(token)]?.symbol || 'N/A'), 1)
                  ]))
                }), 128)),
                _createElementVNode("span", _hoisted_16, "~$" + _toDisplayString(_ctx.fNum2(_ctx.calculatePricesFor(_ctx.totals[week.week]), {
                style: 'decimal',
                maximumFractionDigits: 1,
                abbreviate: true
              })), 1)
              ])
            ])
          }
        })
      ]), 1032, ["columns", "data", "is-loading", "link", "initial-state"])
    ]),
    _: 1
  }))
}